import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import VueAnalytics from 'vue-analytics'

// components
import AppHeader from '@/components/Header.vue'
import AppFooter from '@/components/Footer.vue'
import Weekly from '@/components/Weekly.vue'
import EmailInformation from '@/components/EmailInformation.vue'
import MastHead from '@/components/Masthead.vue'
import CtaNewsletter from '@/components/CtaNewsletter.vue'

Vue.component('app-header', AppHeader)
Vue.component('app-footer', AppFooter)
Vue.component('app-weekly', Weekly)
Vue.component('app-emailinformation', EmailInformation)
Vue.component('app-masthead', MastHead)
Vue.component('app-cta-newsletter', CtaNewsletter)

Vue.use(VueAnalytics, {
  id: 'UA-112415537-1',
  router
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
